export default "__VITE_ASSET__BZm__D0F__"